import {
    Button,
    CircularProgress,
    Fab,
    Grid,
    makeStyles,
    TextField,
    Select,
    TextareaAutosize,
    MenuItem,
} from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import SideNav from '../../components/Admin/SideNav';
import Modal from '../../components/Modal/modal_cancel_save';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { loadRes } from '../../store/res/res.action';
import MUIDataTable from 'mui-datatables';
import axios from '../../axios-default';
import { easySnackbar } from '../../store/Noti/noti.actions';
import join from 'url-join';
import { ApiServerUrl } from '../../config.json';
import NewWarningDialog from '../../components/Dialog/NewWarningDialog';
import { useLang } from '../../util/lang';
import useAuth from '../../hooks/useAuth';

const KnowledgeBaseStyles = makeStyles((theme) => ({
    '@global': {
        body: {
            background: '#fdfdfd',
        },
    },
    root: {
        flexGrow: 1,
    },
    rootContainer: {
        padding: 16,
        margin: '8px 0px 0px 238px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '12px 0px 0px 0px',
            width: '100%',
        },
        width: 'calc(100% - 238px)',
    },
    scanBox: {
        padding: 16,
        margin: '8px 0px',
    },
    textField: {
        // marginLeft: "8px",
        // marginRight: "8px",
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'black',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'grey',
            },
            '&:hover fieldset': {
                borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'black',
            },
        },
    },
    dateField: {
        width: '100%',
    },
    formControl: {
        width: '100%',
    },
    dense: {
        marginTop: 16,
        marginLeft: 0,
    },
    submitBtn: {
        backgroundColor: '#061a2e !important',
        color: 'white',
        padding: '8px 24px',
        margin: '12px 0px',
    },
    linkBtn: {
        background: 'rgba(89,54,135,1)',
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        margin: '16px 0px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            padding: '4px 72px',
            width: 'unset',
        },
        '&:hover': {
            background: 'rgb(77, 74, 142)',
            color: 'white',
        },
    },
}));

const KnowledgeBase = () => {
    const classes = KnowledgeBaseStyles();
    const res = useSelector(({ res }) => res);
    const dispatch = useDispatch();
    const history = useHistory();
    const knowledgeBaseGetLang = useLang('KnowledgeBase');
    const auth = useAuth();
    const { isAuthenticated } = auth;

    const [addArticleModalOpen, setAddArticleModalOpen] = useState(false),
        [addArticleModalError, setAddArticleModalError] = useState(''),
        [addVideoModalOpen, setAddVideoModalOpen] = useState(false),
        [addVideoModalError, setAddVideoModalError] = useState(''),
        [modifyArticleModalOpen, setModifyArticleModalOpen] = useState(false),
        [modifyArticleModalError, setModifyArticleModalError] = useState(''),
        [modifyVideoModalOpen, setModifyVideoModalOpen] = useState(false),
        [modifyVideoModalError, setModifyVideoModalError] = useState(''),
        [updatedAddKnowledgeBaseArticle, setUpdatedAddKnowledgeBaseArticle] = useState({}),
        [updatedModifyKnowledgeBaseArticle, setUpdatedModifyKnowledgeBaseArticle] = useState({}),
        [KnowledgeBaseArticle, setKnowledgeBaseArticle] = useState([]),
        [updatedAddKnowledgeBaseVideo, setUpdatedAddKnowledgeBaseVideo] = useState({}),
        [updatedModifyKnowledgeBaseVideo, setUpdatedModifyKnowledgeBaseVideo] = useState({}),
        [KnowledgeBaseVideo, setKnowledgeBaseVideo] = useState([]),
        [loading, setLoading] = useState(true),
        [isAdminSAdmin, setIsAdminSAdmin] = useState(false),
        [isDistr, setIsDistr] = useState(false),
        [LanguageList, setLanguageList] = useState([]),
        [currentArticleRecordDisplaySequenceNumber, setCurrentArticleRecordDisplaySequenceNumber] = useState(''),
        [currentArticleRecordDisplayGroup, setCurrentArticleRecordDisplayGroup] = useState(''),
        [currentVideoRecordDisplaySequenceNumber, setCurrentVideoRecordDisplaySequenceNumber] = useState(''),
        [currentVideoRecordDisplayGroup, setCurrentVideoRecordDisplayGroup] = useState(''),
        [addSelectedFile, setAddSelectedFile] = useState(null),
        [isAddFilePicked, setIsAddFilePicked] = useState(false),
        [modifySelectedFile, setModifySelectedFile] = useState(null),
        [isModifyFilePicked, setIsModifyFilePicked] = useState(false),
        [isOriginalModifyFile, setIsOriginalModifyFile] = useState(true),
        [deleteKnowledgeBaseWarningOpen, setDeleteKnowledgeBaseWarningOpen] = useState(false),
        [closeAddArticleWarningOpen, setCloseAddArticleWarningOpen] = useState(false),
        [closeModifyArticleWarningOpen, setCloseModifyArticleWarningOpen] = useState(false),
        [closeAddVideoWarningOpen, setCloseAddVideoWarningOpen] = useState(false),
        [closeModifyVideoWarningOpen, setCloseModifyVideoWarningOpen] = useState(false),
        [deleteAddDescriptionFileOpen, setDeleteAddDescriptionFileOpen] = useState(false),
        [deleteModifyDescriptionFileOpen, setDeleteModifyDescriptionFileOpen] = useState(false),
        [deleteKnowledgeBaseID, setDeleteKnowledgeBaseID] = useState(''),
        [fileUrl, setFileUrl] = useState('');

    var langList = {};

    useEffect(() => {
        (async () => {
            try {
                langList = (await axios.get('lang/list')).data.lang.map(
                    (v) => Object.assign((v, { lang_iso_code: v.lang_iso_code }), {}) ?? {}
                );
                setLanguageList(langList);
                setLoading(false);
            } catch (err) {
                console.error(err);
                if (err.response && err.response.statusText === 'Unauthorized') {
                    localStorage.removeItem('auth-token');
                    localStorage.removeItem('expirationDate');
                    localStorage.removeItem('role');
                    history.push('/login');
                }
            }
        })();
    }, []);

    useEffect(() => {
        if ((localStorage.role == '"SADMIN"') | (localStorage.role == '"ADMIN"')) {
            setIsAdminSAdmin(true);
        } else if (localStorage.role == '"DISTR"') {
            setIsDistr(true);
        }
    }, []);

    useEffect(() => {
        setCurrentArticleRecordDisplaySequenceNumber(updatedModifyKnowledgeBaseArticle.display_sequence_number);
        setCurrentArticleRecordDisplayGroup(updatedModifyKnowledgeBaseArticle.distr_group_id);
    }, [modifyArticleModalOpen, currentArticleRecordDisplaySequenceNumber, currentArticleRecordDisplayGroup]);

    useEffect(() => {
        setCurrentVideoRecordDisplaySequenceNumber(updatedModifyKnowledgeBaseVideo.display_sequence_number);
        setCurrentVideoRecordDisplayGroup(updatedModifyKnowledgeBaseVideo.distr_group_id);
    }, [modifyVideoModalOpen, currentVideoRecordDisplaySequenceNumber, currentVideoRecordDisplayGroup]);

    useEffect(() => {
        (async () => {
            try {
                if (isAdminSAdmin) {
                    var obj1 = Object.values(res.knowledge_base_article)
                        .filter((a) => a.distr_group_name == 'ALL')
                        .sort((a, b) => a.display_sequence_number - b.display_sequence_number)
                        .map((g) => ({
                            distributor_group_name: g.distr_group_name,
                            display_sequence_number: parseInt(g.display_sequence_number, 10),
                            language: g.lang_iso_code,
                            title: g.title,
                            description: g.description_text,
                            description_file: g.description_file_name,
                            id: g,
                        }));

                    var obj2 = Object.values(res.knowledge_base_article)
                        .filter((c) => c.distr_group_name != 'ALL')
                        .sort((c, d) => c.display_sequence_number - d.display_sequence_number)
                        .sort((c, d) => c.distr_group_name.localeCompare(d.distr_group_name))
                        .map((g) => ({
                            distributor_group_name: g.distr_group_name,
                            display_sequence_number: parseInt(g.display_sequence_number, 10),
                            language: g.lang_iso_code,
                            title: g.title,
                            description: g.description_text,
                            description_file: g.description_file_name,
                            id: g,
                        }));

                    setKnowledgeBaseArticle(obj1.concat(obj2));
                } else if (isDistr) {
                    setKnowledgeBaseArticle(
                        Object.values(res.knowledge_base_article)
                            .filter((a) => a.distr_group_id == localStorage.distr_group_id.replace(/['"]+/g, ''))
                            .sort((a, b) => a.display_sequence_number - b.display_sequence_number)
                            .map((g) => ({
                                distributor_group_name: g.distr_group_name,
                                display_sequence_number: parseInt(g.display_sequence_number, 10),
                                language: g.lang_iso_code,
                                title: g.title,
                                description: g.description_text,
                                description_file: g.description_file_name,
                                id: g,
                            }))
                    );
                }

                setLoading(false);
                setUpdatedAddKnowledgeBaseArticle({});
                setUpdatedModifyKnowledgeBaseArticle({});
            } catch (err) {
                console.error(err);
                if (err.response && err.response.statusText === 'Unauthorized') {
                    localStorage.removeItem('auth-token');
                    localStorage.removeItem('expirationDate');
                    localStorage.removeItem('role');
                    history.push('/login');
                }
            }
        })();
    }, [res.knowledge_base_article, isAdminSAdmin, isDistr]);

    const ColumnsArticle = useMemo(
        () => [
            {
                name: 'distributor_group_name',
                label: knowledgeBaseGetLang('distributorGroupName'),
                options: {
                    filter: true,
                    sort: true,
                    display: isAdminSAdmin,
                },
            },
            {
                name: 'display_sequence_number',
                label: knowledgeBaseGetLang('displaySequenceNumber'),
                options: {
                    filter: true,
                    sort: true,
                },
            },
            {
                name: 'language',
                label: knowledgeBaseGetLang('language'),
                options: {
                    filter: true,
                    sort: true,
                },
            },
            {
                name: 'title',
                label: knowledgeBaseGetLang('title'),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <div style={{ whiteSpace: 'normal', maxWidth: '200px', overflowWrap: 'break-word' }}>
                            {value}
                        </div>
                    ),
                },
            },
            {
                name: 'description',
                label: knowledgeBaseGetLang('description'),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <div style={{ maxWidth: '600px', overflowWrap: 'break-word' }}>{value}</div>
                    ),
                },
            },
            {
                name: 'description_file',
                label: knowledgeBaseGetLang('descriptionFile'),
                options: {
                    filter: true,
                    sort: true,
                },
            },
            {
                name: 'id',
                label: knowledgeBaseGetLang('action'),
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <div style={{ display: 'flex' }}>
                                <Fab
                                    size="small"
                                    aria-label="add"
                                    style={{
                                        backgroundColor: '#75a0de',
                                        color: 'white',
                                        margin: '0px 4px',
                                    }}
                                    onClick={() => {
                                        setUpdatedModifyKnowledgeBaseArticle(Object.assign({}, value));
                                        setModifyArticleModalOpen(true);
                                    }}
                                >
                                    <EditIcon />
                                </Fab>
                                <Fab
                                    size="small"
                                    aria-label="add"
                                    style={{
                                        backgroundColor: '#da5851',
                                        color: 'white',
                                        margin: '0px 4px',
                                    }}
                                    onClick={() => {
                                        setDeleteKnowledgeBaseID(value.knowledge_base_id);
                                        setDeleteKnowledgeBaseWarningOpen(true);
                                    }}
                                >
                                    <DeleteOutlineIcon />
                                </Fab>
                            </div>
                        );
                    },
                },
            },
        ],
        [isAdminSAdmin, deleteKnowledgeBaseWarningOpen, deleteKnowledgeBaseID]
    );

    useEffect(() => {
        (async () => {
            try {
                if (isAdminSAdmin) {
                    var obj1 = Object.values(res.knowledge_base_video)
                        .filter((a) => a.distr_group_name == 'ALL')
                        .sort((a, b) => a.display_sequence_number - b.display_sequence_number)
                        .map((g) => ({
                            distributor_group_name: g.distr_group_name,
                            display_sequence_number: parseInt(g.display_sequence_number, 10),
                            language: g.lang_iso_code,
                            title: g.title,
                            video_url: g.video_url,
                            id: g,
                        }));

                    var obj2 = Object.values(res.knowledge_base_video)
                        .filter((c) => c.distr_group_name != 'ALL')
                        .sort((c, d) => c.display_sequence_number - d.display_sequence_number)
                        .sort((c, d) => c.distr_group_name.localeCompare(d.distr_group_name))
                        .map((g) => ({
                            distributor_group_name: g.distr_group_name,
                            display_sequence_number: parseInt(g.display_sequence_number, 10),
                            language: g.lang_iso_code,
                            title: g.title,
                            video_url: g.video_url,
                            id: g,
                        }));

                    setKnowledgeBaseVideo(obj1.concat(obj2));
                } else if (isDistr) {
                    setKnowledgeBaseVideo(
                        Object.values(res.knowledge_base_video)
                            .filter((a) => a.distr_group_id == localStorage.distr_group_id.replace(/['"]+/g, ''))
                            .sort((a, b) => a.display_sequence_number - b.display_sequence_number)
                            .map((g) => ({
                                distributor_group_name: g.distr_group_name,
                                display_sequence_number: parseInt(g.display_sequence_number, 10),
                                language: g.lang_iso_code,
                                title: g.title,
                                video_url: g.video_url,
                                id: g,
                            }))
                    );
                }

                setLoading(false);
                setUpdatedAddKnowledgeBaseVideo({});
                setUpdatedModifyKnowledgeBaseVideo({});
            } catch (err) {
                console.error(err);
                if (err.response && err.response.statusText === 'Unauthorized') {
                    localStorage.removeItem('auth-token');
                    localStorage.removeItem('expirationDate');
                    localStorage.removeItem('role');
                    history.push('/login');
                }
            }
        })();
    }, [res.knowledge_base_video, isAdminSAdmin, isDistr]);

    const ColumnsVideo = useMemo(
        () => [
            {
                name: 'distributor_group_name',
                label: knowledgeBaseGetLang('distributorGroupName'),
                options: {
                    filter: true,
                    sort: true,
                    display: isAdminSAdmin,
                },
            },
            {
                name: 'display_sequence_number',
                label: knowledgeBaseGetLang('displaySequenceNumber'),
                options: {
                    filter: true,
                    sort: true,
                },
            },
            {
                name: 'language',
                label: knowledgeBaseGetLang('language'),
                options: {
                    filter: true,
                    sort: true,
                },
            },
            {
                name: 'title',
                label: knowledgeBaseGetLang('title'),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <div style={{ whiteSpace: 'normal', maxWidth: '200px', overflowWrap: 'break-word' }}>
                            {value}
                        </div>
                    ),
                },
            },
            {
                name: 'video_url',
                label: knowledgeBaseGetLang('videoURL'),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <div style={{ whiteSpace: 'normal', maxWidth: '400px', overflowWrap: 'break-word' }}>
                            {value}
                        </div>
                    ),
                },
            },
            {
                name: 'id',
                label: knowledgeBaseGetLang('action'),
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <div style={{ display: 'flex' }}>
                                <Fab
                                    size="small"
                                    aria-label="add"
                                    style={{
                                        backgroundColor: '#75a0de',
                                        color: 'white',
                                        margin: '0px 4px',
                                    }}
                                    onClick={() => {
                                        setUpdatedModifyKnowledgeBaseVideo(Object.assign({}, value));
                                        setModifyVideoModalOpen(true);
                                    }}
                                >
                                    <EditIcon />
                                </Fab>
                                <Fab
                                    size="small"
                                    aria-label="add"
                                    style={{
                                        backgroundColor: '#da5851',
                                        color: 'white',
                                        margin: '0px 4px',
                                    }}
                                    onClick={() => {
                                        setDeleteKnowledgeBaseID(value.knowledge_base_id);
                                        setDeleteKnowledgeBaseWarningOpen(true);
                                    }}
                                >
                                    <DeleteOutlineIcon />
                                </Fab>
                            </div>
                        );
                    },
                },
            },
        ],
        [isAdminSAdmin, deleteKnowledgeBaseWarningOpen, deleteKnowledgeBaseID]
    );

    const reloadPage = async () => {
        const curPage = window.location.pathname;
        history.push('/blank');
        history.replace(curPage);
        await loadRes(isAuthenticated)(dispatch);
    };

    const handleAddUpdateArticle = useCallback(
        (field) =>
            ({ target: { value } }) => {
                setUpdatedAddKnowledgeBaseArticle({
                    ...updatedAddKnowledgeBaseArticle,
                    [field]: value,
                });
            },
        [updatedAddKnowledgeBaseArticle]
    );

    const handleModifyUpdateArticle = useCallback(
        (field) =>
            ({ target: { value } }) => {
                setUpdatedModifyKnowledgeBaseArticle({
                    ...updatedModifyKnowledgeBaseArticle,
                    [field]: value,
                });
            },
        [updatedModifyKnowledgeBaseArticle]
    );

    const handleAddUpdateVideo = useCallback(
        (field) =>
            ({ target: { value } }) => {
                setUpdatedAddKnowledgeBaseVideo({
                    ...updatedAddKnowledgeBaseVideo,
                    [field]: value,
                });
            },
        [updatedAddKnowledgeBaseVideo]
    );

    const handleModifyUpdateVideo = useCallback(
        (field) =>
            ({ target: { value } }) => {
                setUpdatedModifyKnowledgeBaseVideo({
                    ...updatedModifyKnowledgeBaseVideo,
                    [field]: value,
                });
            },
        [updatedModifyKnowledgeBaseVideo]
    );

    const handleAddSaveArticle = useCallback(async () => {
        try {
            if (loading) return;
            setLoading(true);
            if (isDistr) {
                updatedAddKnowledgeBaseArticle.distr_group_id = localStorage.distr_group_id.replace(/['"]+/g, '');
            }

            if (String.isBlank(updatedAddKnowledgeBaseArticle.distr_group_id)) {
                return setAddArticleModalError('Distribute Group Name is required');
            } else if (String.isBlank(updatedAddKnowledgeBaseArticle.lang_id)) {
                return setAddArticleModalError('Language is required');
            } else if (String.isBlank(updatedAddKnowledgeBaseArticle.title)) {
                return setAddArticleModalError('Title is required');
            } else if (
                String.isBlank(updatedAddKnowledgeBaseArticle.description_text) &&
                String.isBlank(updatedAddKnowledgeBaseArticle.description_file)
            ) {
                return setAddArticleModalError('Please provide Description or Description File or Both');
            }

            updatedAddKnowledgeBaseArticle.type_name = 'article';

            const formData = new FormData();
            formData.append('distr_group_id', updatedAddKnowledgeBaseArticle.distr_group_id);
            formData.append('lang_id', updatedAddKnowledgeBaseArticle.lang_id);
            formData.append('title', updatedAddKnowledgeBaseArticle.title);
            if (!String.isBlank(updatedAddKnowledgeBaseArticle.description_text)) {
                formData.append('description_text', updatedAddKnowledgeBaseArticle.description_text);
            }
            if (!String.isBlank(updatedAddKnowledgeBaseArticle.description_file)) {
                formData.append('description_file', addSelectedFile);
            }
            formData.append('type_name', updatedAddKnowledgeBaseArticle.type_name);
            await axios.post(`res/knowledgebase`, formData);

            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            dispatch(easySnackbar('Knowledge record saved successfully.', 'success'));

            reloadPage();
            setLoading(true);
            setAddVideoModalOpen(false);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.push('/login');
            } else {
                dispatch(easySnackbar(err.response?.data?.message ?? err.message ?? err, 'error'));
            }
        } finally {
            setLoading(false);
        }
    }, [updatedAddKnowledgeBaseArticle, addSelectedFile, isAddFilePicked]);

    const handleModifySaveArticle = useCallback(async () => {
        try {
            if (loading) return;
            setLoading(true);
            if (isDistr) {
                updatedModifyKnowledgeBaseArticle.distr_group_id = localStorage.distr_group_id.replace(/['"]+/g, '');
            }
            if (String.isBlank(updatedModifyKnowledgeBaseArticle.distr_group_id.toString())) {
                return setModifyArticleModalError('Distribute Group Name is required');
            } else if (String.isBlank(updatedModifyKnowledgeBaseArticle.display_sequence_number.toString())) {
                return setModifyArticleModalError('Display Sequence Number is required');
            } else if (
                parseInt(updatedModifyKnowledgeBaseArticle.display_sequence_number) <= 0 ||
                parseInt(updatedModifyKnowledgeBaseArticle.display_sequence_number) > 999999
            ) {
                return setModifyArticleModalError('Valid Display Sequence Number is between 1 to 999999');
            } else if (String.isBlank(updatedModifyKnowledgeBaseArticle.lang_id.toString())) {
                return setModifyArticleModalError('Language is required');
            } else if (String.isBlank(updatedModifyKnowledgeBaseArticle.title)) {
                return setModifyArticleModalError('Title is required');
            } else if (
                String.isBlank(updatedModifyKnowledgeBaseArticle.description_text) &&
                String.isBlank(updatedModifyKnowledgeBaseArticle.description_file_name)
            ) {
                return setModifyArticleModalError('Please provide Description or Description File or Both');
            }
            updatedModifyKnowledgeBaseArticle.type_name = 'article';

            const formData = new FormData();
            formData.append('distr_group_id', updatedModifyKnowledgeBaseArticle.distr_group_id);
            formData.append('lang_id', updatedModifyKnowledgeBaseArticle.lang_id);
            formData.append('title', updatedModifyKnowledgeBaseArticle.title);
            if (!String.isBlank(updatedModifyKnowledgeBaseArticle.description_text)) {
                formData.append('description_text', updatedModifyKnowledgeBaseArticle.description_text);
            }
            if (!String.isBlank(updatedModifyKnowledgeBaseArticle.description_file_name)) {
                formData.append('description_file', modifySelectedFile);
            }
            if (isOriginalModifyFile) {
                formData.append('description_file', 'isOriginalModifyFile');
            }
            formData.append('display_sequence_number', updatedModifyKnowledgeBaseArticle.display_sequence_number);
            formData.append('type_name', updatedModifyKnowledgeBaseArticle.type_name);
            formData.append('current_display_group_id', currentArticleRecordDisplayGroup);
            formData.append('current_display_sequence_number', currentArticleRecordDisplaySequenceNumber);

            await axios.put(`res/knowledgebase/${updatedModifyKnowledgeBaseArticle.knowledge_base_id}`, formData);
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            dispatch(easySnackbar('Knowledge record saved successfully.', 'success'));

            reloadPage();
            setLoading(true);
            setAddVideoModalOpen(false);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.push('/login');
            } else {
                dispatch(easySnackbar(err.response?.data?.message ?? err.message ?? err, 'error'));
            }
        } finally {
            setLoading(false);
        }
    }, [
        updatedModifyKnowledgeBaseArticle,
        currentArticleRecordDisplaySequenceNumber,
        modifySelectedFile,
        isModifyFilePicked,
        isOriginalModifyFile,
        currentArticleRecordDisplaySequenceNumber,
        currentArticleRecordDisplayGroup,
    ]);

    const handleAddSaveVideo = useCallback(async () => {
        try {
            if (loading) return;
            setLoading(true);
            if (isDistr) {
                updatedAddKnowledgeBaseVideo.distr_group_id = localStorage.distr_group_id.replace(/['"]+/g, '');
            }
            if (String.isBlank(updatedAddKnowledgeBaseVideo.distr_group_id)) {
                return setAddVideoModalError('Distribtor Group Name is required');
            } else if (String.isBlank(updatedAddKnowledgeBaseVideo.lang_id)) {
                return setAddVideoModalError('Language is required');
            } else if (String.isBlank(updatedAddKnowledgeBaseVideo.title)) {
                return setAddVideoModalError('Title is required');
            } else if (String.isBlank(updatedAddKnowledgeBaseVideo.video_url)) {
                return setAddVideoModalError('Video URL is required');
            }
            updatedAddKnowledgeBaseVideo.type_name = 'video';
            updatedAddKnowledgeBaseVideo.distr_group_id = parseInt(updatedAddKnowledgeBaseVideo.distr_group_id);
            updatedAddKnowledgeBaseVideo.lang_id = parseInt(updatedAddKnowledgeBaseVideo.lang_id);

            await axios.post(`res/knowledgebase`, updatedAddKnowledgeBaseVideo);
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            dispatch(easySnackbar('Knowledge record saved successfully.', 'success'));

            reloadPage();
            setLoading(true);
            setModifyVideoModalOpen(false);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.push('/login');
            } else {
                dispatch(easySnackbar(err.response?.data?.message ?? err.message ?? err, 'error'));
            }
        } finally {
            setLoading(false);
        }
    }, [updatedAddKnowledgeBaseVideo]);

    const handleModifySaveVideo = useCallback(async () => {
        try {
            if (loading) return;
            setLoading(true);
            if (isDistr) {
                updatedModifyKnowledgeBaseVideo.distr_group_id = localStorage.distr_group_id.replace(/['"]+/g, '');
            }
            if (String.isBlank(updatedModifyKnowledgeBaseVideo.distr_group_id.toString())) {
                return setModifyVideoModalError('Distribtor Group Name is required');
            } else if (String.isBlank(updatedModifyKnowledgeBaseVideo.display_sequence_number.toString())) {
                return setModifyVideoModalError('Display Sequence Number is required');
            } else if (
                parseInt(updatedModifyKnowledgeBaseVideo.display_sequence_number) <= 0 ||
                parseInt(updatedModifyKnowledgeBaseVideo.display_sequence_number) > 999999
            ) {
                return setModifyVideoModalError('Valid Display Sequence Number is between 1 to 999999');
            } else if (String.isBlank(updatedModifyKnowledgeBaseVideo.lang_id.toString())) {
                return setModifyVideoModalError('Language is required');
            } else if (String.isBlank(updatedModifyKnowledgeBaseVideo.title)) {
                return setModifyVideoModalError('Title is required');
            } else if (String.isBlank(updatedModifyKnowledgeBaseVideo.video_url)) {
                return setModifyVideoModalError('Video URL is required');
            }
            updatedModifyKnowledgeBaseVideo.type_name = 'video';
            updatedModifyKnowledgeBaseVideo.distr_group_id = parseInt(updatedModifyKnowledgeBaseVideo.distr_group_id);
            updatedModifyKnowledgeBaseVideo.lang_id = parseInt(updatedModifyKnowledgeBaseVideo.lang_id);

            updatedModifyKnowledgeBaseVideo.current_display_group_id = currentVideoRecordDisplayGroup;
            updatedModifyKnowledgeBaseVideo.current_display_sequence_number = currentVideoRecordDisplaySequenceNumber;

            await axios.put(
                `res/knowledgebase/${updatedModifyKnowledgeBaseVideo.knowledge_base_id}`,
                updatedModifyKnowledgeBaseVideo
            );
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            dispatch(easySnackbar('Knowledge record saved successfully.', 'success'));

            reloadPage();
            setLoading(true);
            setModifyVideoModalOpen(false);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.push('/login');
            } else {
                dispatch(easySnackbar(err.response?.data?.message ?? err.message ?? err, 'error'));
            }
        } finally {
            setLoading(false);
        }
    }, [updatedModifyKnowledgeBaseVideo, currentVideoRecordDisplaySequenceNumber, currentVideoRecordDisplayGroup]);

    function RedColorText({ children }) {
        return <span style={{ color: 'red' }}>{children}</span>;
    }

    const distriGroupNameSelect = useMemo(
        () =>
            Object.entries(res.distr_groups)
                .filter(([a, b]) => b.distr_group_name == 'ALL')
                .map(([n, c]) => (
                    <MenuItem value={n} key={n}>
                        {c.distr_group_name}
                    </MenuItem>
                ))
                .concat(
                    Object.entries(res.distr_groups)
                        .filter(([a, b]) => b.distr_group_name != 'ALL')
                        .sort(([a, b], [c, d]) => b.distr_group_name.localeCompare(d.distr_group_name))
                        .map(([n, c]) => (
                            <MenuItem value={n} key={n}>
                                {c.distr_group_name}
                            </MenuItem>
                        ))
                ),
        [res?.distr_groups]
    );

    const langIsoCodeSelect = useMemo(
        () =>
            Object.entries(LanguageList).map(([n, c]) => (
                <MenuItem value={(parseInt(n) + 1).toString()} key={(parseInt(n) + 1).toString()}>
                    {c.lang_iso_code}
                </MenuItem>
            )),
        [LanguageList]
    );

    const currentSystemLang =
        localStorage.lang.replace(/['"]+/g, '') == 'en' ? 'English' : localStorage.lang.replace(/['"]+/g, '');
    const currentSystemLangId = (
        parseInt(LanguageList.map((e) => e.lang_iso_code).indexOf(currentSystemLang)) + 1
    ).toString();

    const changeAddHandler = (event) => {
        const file = event.target.files[0];
        event.target.value = '';

        if (file.size > 10 * 1024 * 1024) {
            setAddArticleModalError('File size Cannot exceed 10MB.');
            return;
        } else if (
            !['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.jpg', '.png', '.gif', '.svg'].some((t) =>
                file.name.endsWith(t)
            )
        ) {
            setAddArticleModalError(
                'Please upload Description File in one of the following formats: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, GIF, SVG'
            );
            return;
        } else {
            setAddArticleModalError('');
        }

        const url = URL.createObjectURL(file);

        setFileUrl(url);
        setAddSelectedFile(file);
        setIsAddFilePicked(true);
    };

    const changeModifyHandler = (event) => {
        const file = event.target.files[0];
        event.target.value = '';

        if (file.size > 10 * 1024 * 1024) {
            setModifyArticleModalError('File size Cannot exceed 10MB.');
            return;
        } else if (
            !['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.jpg', '.png', '.gif', '.svg'].some((t) =>
                file.name.endsWith(t)
            )
        ) {
            setModifyArticleModalError(
                'Please upload Description File in one of the following formats: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, GIF, SVG'
            );
            return;
        } else {
            setModifyArticleModalError('');
        }

        const url = URL.createObjectURL(file);
        setFileUrl(url);

        setModifySelectedFile(file);
        setIsModifyFilePicked(true);
        setIsOriginalModifyFile(false);
    };

    return (
        <div>
            <SideNav />
            <Grid container className={classes.rootContainer}></Grid>
            <Grid container className={classes.rootContainer} style={{ marginTop: 0 }}>
                {!loading ? (
                    <div style={{ display: 'contents' }}>
                        <Grid container>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    padding: 8,
                                }}
                            >
                                <h1
                                    style={{
                                        marginBlockEnd: 0,
                                    }}
                                >
                                    {knowledgeBaseGetLang('knowledgeBase')}
                                </h1>

                                <hr />
                            </Grid>

                            <Grid item xs={12} style={{ padding: 8 }}>
                                <Button className={classes.linkBtn} onClick={() => setAddArticleModalOpen(true)}>
                                    {knowledgeBaseGetLang('addKnowledgeArticle')}
                                </Button>
                                <Button
                                    style={{ margin: 8 }}
                                    className={classes.linkBtn}
                                    onClick={() => setAddVideoModalOpen(true)}
                                >
                                    {knowledgeBaseGetLang('addKnowledgeVideo')}
                                </Button>
                                <MUIDataTable
                                    title={knowledgeBaseGetLang('article')}
                                    data={KnowledgeBaseArticle}
                                    columns={ColumnsArticle}
                                    options={{
                                        download: false,
                                        filterType: 'dropdown',
                                        responsive: 'scroll',
                                        selectableRows: false,
                                        rowsPerPage: 30,
                                        rowsPerPageOptions: [15, 30, 50],
                                    }}
                                />
                                <br />
                                <MUIDataTable
                                    title={knowledgeBaseGetLang('video')}
                                    data={KnowledgeBaseVideo}
                                    columns={ColumnsVideo}
                                    options={{
                                        download: false,
                                        filterType: 'dropdown',
                                        responsive: 'scroll',
                                        selectableRows: false,
                                        rowsPerPage: 30,
                                        rowsPerPageOptions: [15, 30, 50],
                                    }}
                                />
                                <NewWarningDialog
                                    title="Warning Message:"
                                    open={closeAddArticleWarningOpen}
                                    setOpen={setCloseAddArticleWarningOpen}
                                    onOk={() => {
                                        setCloseAddArticleWarningOpen(false);
                                        setAddArticleModalOpen(false);
                                        setUpdatedAddKnowledgeBaseArticle({});
                                        setIsAddFilePicked(false);
                                        setAddSelectedFile('');
                                        setAddArticleModalError('');
                                    }}
                                >
                                    If you cancel, updated information will NOT be saved.
                                </NewWarningDialog>
                                <Modal
                                    className="modal"
                                    modal="Add Knowledge - Article"
                                    title="Add Knowledge - Article"
                                    open={addArticleModalOpen}
                                    handleClose={() => setCloseAddArticleWarningOpen(true)}
                                    handleDataSave={() => handleAddSaveArticle()}
                                    modalError={addArticleModalError}
                                    submitButton={true}
                                >
                                    <>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>
                                                Fields marked with an asterisk (<RedColorText>*</RedColorText>) are
                                                mandatory
                                            </p>
                                        </Grid>
                                        {isAdminSAdmin && (
                                            <Grid item xs={12} style={{ padding: 4 }}>
                                                <p>
                                                    Distributor Group Name <RedColorText>*</RedColorText>
                                                </p>
                                                <Select
                                                    displayEmpty
                                                    onChange={handleAddUpdateArticle('distr_group_id')}
                                                    style={{ width: '100%' }}
                                                    value={updatedAddKnowledgeBaseArticle.distr_group_id}
                                                >
                                                    {distriGroupNameSelect}
                                                </Select>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>
                                                Language <RedColorText>*</RedColorText>
                                            </p>
                                            <Select
                                                displayEmpty
                                                onChange={handleAddUpdateArticle('lang_id')}
                                                style={{ width: '100%' }}
                                                value={
                                                    !updatedAddKnowledgeBaseArticle.lang_id ||
                                                    updatedAddKnowledgeBaseArticle.lang_id == 0
                                                        ? (updatedAddKnowledgeBaseArticle.lang_id = currentSystemLangId)
                                                        : updatedAddKnowledgeBaseArticle.lang_id
                                                }
                                            >
                                                {langIsoCodeSelect}
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>
                                                Title (Maximum 200 Characters)<RedColorText>*</RedColorText>
                                            </p>
                                            <TextField
                                                id="title"
                                                style={{ width: '100%' }}
                                                value={updatedAddKnowledgeBaseArticle.title}
                                                onChange={handleAddUpdateArticle('title')}
                                                inputProps={{ maxLength: 200 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>
                                                Please provide Description or Description File or Both{' '}
                                                <RedColorText>*</RedColorText>
                                            </p>
                                            <p>Description (Maximum 3,000 Characters)</p>
                                            <TextareaAutosize
                                                id="description_text"
                                                label="DescriptionText"
                                                margin="normal"
                                                rowsMin={3}
                                                style={{ width: '100%' }}
                                                value={updatedAddKnowledgeBaseArticle.description_text}
                                                onChange={handleAddUpdateArticle('description_text')}
                                                maxLength={3000}
                                            />
                                        </Grid>

                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Description File (Maximum 10 MB)</p>
                                            {isAddFilePicked ? (
                                                <>
                                                    <span style={{ paddingLeft: 4 }}>
                                                        Existing Description File : &nbsp;
                                                    </span>
                                                    <a href={fileUrl} target="_blank">
                                                        <span>
                                                            {
                                                                (updatedAddKnowledgeBaseArticle.description_file =
                                                                    addSelectedFile.name)
                                                            }
                                                        </span>
                                                    </a>
                                                    <span>&nbsp;</span>
                                                    <Fab
                                                        size="small"
                                                        aria-label="add"
                                                        style={{
                                                            backgroundColor: '#da5851',
                                                            color: 'white',
                                                            margin: '0px 4px',
                                                        }}
                                                        onClick={() => {
                                                            setDeleteAddDescriptionFileOpen(true);
                                                        }}
                                                    >
                                                        <DeleteOutlineIcon />
                                                    </Fab>
                                                    <NewWarningDialog
                                                        title="Warning Message:"
                                                        open={deleteAddDescriptionFileOpen}
                                                        setOpen={setDeleteAddDescriptionFileOpen}
                                                        onOk={() => {
                                                            setDeleteAddDescriptionFileOpen(false);
                                                            updatedAddKnowledgeBaseArticle.description_file = '';
                                                            setAddSelectedFile(null);
                                                            setIsAddFilePicked(false);
                                                        }}
                                                    >
                                                        Are you going to delete this Description File?
                                                    </NewWarningDialog>
                                                    <p>
                                                        Please upload new Description File in one of the following
                                                        formats if replacement needed:
                                                    </p>
                                                </>
                                            ) : (
                                                <p>Please upload Description File in one of the following formats:</p>
                                            )}
                                            <p>PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, GIF, SVG</p>
                                            <Button
                                                variant="contained"
                                                component="label"
                                                style={{
                                                    backgroundColor: '#593687',
                                                    color: 'white',
                                                    fontSize: '30px',
                                                    width: '30px',
                                                    height: '35px',
                                                }}
                                            >
                                                +
                                                <input
                                                    type="file"
                                                    name="file"
                                                    onChange={changeAddHandler}
                                                    hidden
                                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.png,.gif,.svg"
                                                />
                                            </Button>
                                        </Grid>
                                    </>
                                </Modal>
                                <NewWarningDialog
                                    title="Warning Message:"
                                    open={closeModifyArticleWarningOpen}
                                    setOpen={setCloseModifyArticleWarningOpen}
                                    onOk={() => {
                                        setCloseModifyArticleWarningOpen(false);
                                        setModifyArticleModalOpen(false);
                                        setUpdatedModifyKnowledgeBaseArticle({});
                                        setIsModifyFilePicked(false);
                                        setModifySelectedFile(null);
                                        setIsOriginalModifyFile(true);
                                        setModifyArticleModalError('');
                                    }}
                                >
                                    If you cancel, updated information will NOT be saved.
                                </NewWarningDialog>
                                <Modal
                                    className="modal"
                                    modal="Modify Knowledge - Article"
                                    title="Modify Knowledge - Article"
                                    open={modifyArticleModalOpen}
                                    handleClose={() => setCloseModifyArticleWarningOpen(true)}
                                    handleDataSave={() => handleModifySaveArticle()}
                                    modalError={modifyArticleModalError}
                                    submitButton={true}
                                >
                                    <>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>
                                                Fields marked with an asterisk (<RedColorText>*</RedColorText>) are
                                                mandatory
                                            </p>
                                        </Grid>
                                        {isAdminSAdmin && (
                                            <Grid item xs={12} style={{ padding: 4 }}>
                                                <p>
                                                    Distributor Group Name <RedColorText>*</RedColorText>
                                                </p>
                                                <Select
                                                    displayEmpty
                                                    onChange={handleModifyUpdateArticle('distr_group_id')}
                                                    style={{ width: '100%' }}
                                                    value={updatedModifyKnowledgeBaseArticle.distr_group_id}
                                                >
                                                    {distriGroupNameSelect}
                                                </Select>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Display Sequence Number (Automatically resequencing when necessary)</p>
                                            <TextField
                                                id="display_sequence_number"
                                                style={{ width: '100%' }}
                                                value={
                                                    isNaN(
                                                        parseInt(
                                                            updatedModifyKnowledgeBaseArticle.display_sequence_number
                                                        )
                                                    )
                                                        ? ''
                                                        : parseInt(
                                                              updatedModifyKnowledgeBaseArticle.display_sequence_number
                                                          )
                                                }
                                                onChange={handleModifyUpdateArticle('display_sequence_number')}
                                            />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>
                                                Language <RedColorText>*</RedColorText>
                                            </p>
                                            <Select
                                                displayEmpty
                                                onChange={handleModifyUpdateArticle('lang_id')}
                                                style={{ width: '100%' }}
                                                value={updatedModifyKnowledgeBaseArticle.lang_id}
                                            >
                                                {langIsoCodeSelect}
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>
                                                Title (Maximum 200 Characters) <RedColorText>*</RedColorText>
                                            </p>
                                            <TextField
                                                id="title"
                                                style={{ width: '100%' }}
                                                value={updatedModifyKnowledgeBaseArticle.title}
                                                onChange={handleModifyUpdateArticle('title')}
                                                inputProps={{ maxLength: 200 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>
                                                Please provide Description or Description File or Both{' '}
                                                <RedColorText>*</RedColorText>
                                            </p>
                                            <p>Description (Maximum 3,000 Characters)</p>
                                            <TextareaAutosize
                                                id="description_text"
                                                label="DescriptionText"
                                                margin="normal"
                                                rowsMin={3}
                                                style={{ width: '100%' }}
                                                value={updatedModifyKnowledgeBaseArticle.description_text}
                                                onChange={handleModifyUpdateArticle('description_text')}
                                                maxLength={3000}
                                            />
                                        </Grid>

                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Description File (Maximum 10 MB)</p>
                                            <span style={{ paddingLeft: 4 }}>Existing Description File : &nbsp;</span>
                                            {isOriginalModifyFile ? (
                                                <>
                                                    {updatedModifyKnowledgeBaseArticle.description_file_path ==
                                                    undefined ? null : (
                                                        <a
                                                            href={join(
                                                                ApiServerUrl,
                                                                '/file/formOrKnowledge?path=',
                                                                updatedModifyKnowledgeBaseArticle.description_file_path,
                                                                '&fileName=',
                                                                updatedModifyKnowledgeBaseArticle.description_file_name
                                                            )}
                                                            target="_blank"
                                                        >
                                                            {updatedModifyKnowledgeBaseArticle.description_file_name}
                                                        </a>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {isModifyFilePicked ? (
                                                        <a href={fileUrl} target="_blank">
                                                            <span>
                                                                {
                                                                    (updatedModifyKnowledgeBaseArticle.description_file_name =
                                                                        modifySelectedFile.name)
                                                                }
                                                            </span>
                                                        </a>
                                                    ) : null}
                                                </>
                                            )}

                                            {!String.isBlank(
                                                updatedModifyKnowledgeBaseArticle.description_file_name
                                            ) ? (
                                                <>
                                                    <Fab
                                                        size="small"
                                                        aria-label="add"
                                                        style={{
                                                            backgroundColor: '#da5851',
                                                            color: 'white',
                                                            margin: '0px 4px',
                                                        }}
                                                        onClick={() => {
                                                            setDeleteModifyDescriptionFileOpen(true);
                                                        }}
                                                    >
                                                        <DeleteOutlineIcon />
                                                    </Fab>
                                                    <NewWarningDialog
                                                        title="Warning Message:"
                                                        open={deleteModifyDescriptionFileOpen}
                                                        setOpen={setDeleteModifyDescriptionFileOpen}
                                                        onOk={() => {
                                                            setDeleteModifyDescriptionFileOpen(false);
                                                            updatedModifyKnowledgeBaseArticle.description_file_name =
                                                                '';
                                                            setIsOriginalModifyFile(false);
                                                            setModifySelectedFile(null);
                                                            setIsModifyFilePicked(false);
                                                        }}
                                                    >
                                                        Are you going to delete this Description File?
                                                    </NewWarningDialog>
                                                </>
                                            ) : null}

                                            <p>
                                                Please upload new Description File in one of the following formats if
                                                replacement needed:
                                            </p>
                                            <p>PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, GIF, SVG</p>

                                            <Button
                                                variant="contained"
                                                component="label"
                                                style={{
                                                    backgroundColor: '#593687',
                                                    color: 'white',
                                                    fontSize: '30px',
                                                    width: '30px',
                                                    height: '35px',
                                                }}
                                            >
                                                +
                                                <input
                                                    type="file"
                                                    name="file"
                                                    onChange={changeModifyHandler}
                                                    hidden
                                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.png,.gif,.svg"
                                                />
                                            </Button>
                                        </Grid>
                                    </>
                                </Modal>
                                <NewWarningDialog
                                    title="Warning Message:"
                                    open={closeAddVideoWarningOpen}
                                    setOpen={setCloseAddVideoWarningOpen}
                                    onOk={() => {
                                        setCloseAddVideoWarningOpen(false);
                                        setAddVideoModalOpen(false);
                                        setUpdatedAddKnowledgeBaseVideo({});
                                        setAddVideoModalError('');
                                    }}
                                >
                                    If you cancel, updated information will NOT be saved.
                                </NewWarningDialog>
                                <Modal
                                    className="modal"
                                    modal="Add Knowledge - Video"
                                    title="Add Knowledge - Video"
                                    open={addVideoModalOpen}
                                    handleClose={() => setCloseAddVideoWarningOpen(true)}
                                    handleDataSave={() => handleAddSaveVideo()}
                                    modalError={addVideoModalError}
                                    submitButton={true}
                                >
                                    <>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Please input all the fields</p>
                                        </Grid>
                                        {isAdminSAdmin && (
                                            <Grid item xs={12} style={{ padding: 4 }}>
                                                <p>Distributor Group Name</p>
                                                <Select
                                                    displayEmpty
                                                    onChange={handleAddUpdateVideo('distr_group_id')}
                                                    style={{ width: '100%' }}
                                                    value={updatedAddKnowledgeBaseVideo.distr_group_id}
                                                >
                                                    {distriGroupNameSelect}
                                                </Select>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Language</p>
                                            <Select
                                                displayEmpty
                                                onChange={handleAddUpdateVideo('lang_id')}
                                                style={{ width: '100%' }}
                                                value={
                                                    !updatedAddKnowledgeBaseVideo.lang_id ||
                                                    updatedAddKnowledgeBaseVideo.lang_id == 0
                                                        ? (updatedAddKnowledgeBaseVideo.lang_id = currentSystemLangId)
                                                        : updatedAddKnowledgeBaseVideo.lang_id
                                                }
                                            >
                                                {langIsoCodeSelect}
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Title (Maximum 200 Characters)</p>
                                            <TextField
                                                id="title"
                                                style={{ width: '100%' }}
                                                value={updatedAddKnowledgeBaseVideo.title}
                                                onChange={handleAddUpdateVideo('title')}
                                                inputProps={{ maxLength: 200 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Video URL</p>
                                            <TextField
                                                id="video_url"
                                                style={{ width: '100%' }}
                                                value={updatedAddKnowledgeBaseVideo.video_url}
                                                onChange={handleAddUpdateVideo('video_url')}
                                            />
                                        </Grid>
                                    </>
                                </Modal>
                                <NewWarningDialog
                                    title="Warning Message:"
                                    open={closeModifyVideoWarningOpen}
                                    setOpen={setCloseModifyVideoWarningOpen}
                                    onOk={() => {
                                        setCloseModifyVideoWarningOpen(false);
                                        setModifyVideoModalOpen(false);
                                        setUpdatedModifyKnowledgeBaseVideo({});
                                        setModifyVideoModalError('');
                                    }}
                                >
                                    If you cancel, updated information will NOT be saved.
                                </NewWarningDialog>
                                <Modal
                                    className="modal"
                                    modal="Modify Knowledge - Video"
                                    title="Modify Knowledge - Video"
                                    open={modifyVideoModalOpen}
                                    handleClose={() => setCloseModifyVideoWarningOpen(true)}
                                    handleDataSave={() => handleModifySaveVideo()}
                                    modalError={modifyVideoModalError}
                                    submitButton={true}
                                >
                                    <>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Please input all the fields</p>
                                        </Grid>
                                        {isAdminSAdmin && (
                                            <Grid item xs={12} style={{ padding: 4 }}>
                                                <p>Distributor Group Name</p>
                                                <Select
                                                    displayEmpty
                                                    onChange={handleModifyUpdateVideo('distr_group_id')}
                                                    style={{ width: '100%' }}
                                                    value={updatedModifyKnowledgeBaseVideo.distr_group_id}
                                                >
                                                    {distriGroupNameSelect}
                                                </Select>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Display Sequence Number (Automatically resequencing when necessary)</p>
                                            <TextField
                                                id="display_sequence_number"
                                                style={{ width: '100%' }}
                                                value={
                                                    isNaN(
                                                        parseInt(
                                                            updatedModifyKnowledgeBaseVideo.display_sequence_number
                                                        )
                                                    )
                                                        ? ''
                                                        : parseInt(
                                                              updatedModifyKnowledgeBaseVideo.display_sequence_number
                                                          )
                                                }
                                                onChange={handleModifyUpdateVideo('display_sequence_number')}
                                            />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Language</p>
                                            <Select
                                                displayEmpty
                                                onChange={handleModifyUpdateVideo('lang_id')}
                                                style={{ width: '100%' }}
                                                value={updatedModifyKnowledgeBaseVideo.lang_id}
                                            >
                                                {langIsoCodeSelect}
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Title (Maximum 200 Characters)</p>
                                            <TextField
                                                id="title"
                                                style={{ width: '100%' }}
                                                value={updatedModifyKnowledgeBaseVideo.title}
                                                onChange={handleModifyUpdateVideo('title')}
                                                inputProps={{ maxLength: 200 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Video URL</p>
                                            <TextField
                                                id="video_url"
                                                style={{ width: '100%' }}
                                                value={updatedModifyKnowledgeBaseVideo.video_url}
                                                onChange={handleModifyUpdateVideo('video_url')}
                                            />
                                        </Grid>
                                    </>
                                </Modal>
                                <NewWarningDialog
                                    title="Warning Message:"
                                    open={deleteKnowledgeBaseWarningOpen}
                                    setOpen={setDeleteKnowledgeBaseWarningOpen}
                                    onOk={async () => {
                                        try {
                                            const { data } = await axios.delete(
                                                `res/knowledgebase/${deleteKnowledgeBaseID}`
                                            );
                                            if (data.success) {
                                                setLoading(true);
                                                reloadPage();
                                                dispatch(
                                                    easySnackbar('Knowledge record deleted successfully.', 'success')
                                                );
                                            } else {
                                                console.error(data.message);
                                            }
                                        } catch (err) {
                                            console.error(err);
                                            if (err.response && err.response.statusText === 'Unauthorized') {
                                                localStorage.removeItem('auth-token');
                                                localStorage.removeItem('expirationDate');
                                                localStorage.removeItem('role');
                                                history.push('/login');
                                            }
                                        }
                                        setDeleteKnowledgeBaseWarningOpen(false);
                                    }}
                                >
                                    Are you going to delete this Knowledge Base record?
                                </NewWarningDialog>
                            </Grid>
                        </Grid>
                    </div>
                ) : (
                    <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress style={{ color: 'rgb(6,26,46)' }} />
                    </Grid>
                )}
            </Grid>
        </div>
    );
};
export default KnowledgeBase;
